import React from 'react';
import { getLandingPageKey } from '../../lib/utils.es6';
import registry from './PartnerLandingPages/index';
import DefaultLandingPage from './LandingPage/LandingPage';

/**
 * LandingPageRouter selects the correct landing page at runtime
 * based on the first subdomain segment of the current hostname.
 *
 * Examples:
 *   inclusivity-aspin.com                    → DefaultLandingPage
 *   staging.inclusivity-aspin.com            → DefaultLandingPage
 *   oldmutual.inclusivity-aspin.com          → OldMutualLandingPage
 *   oldmutual.staging.inclusivity-aspin.com  → OldMutualLandingPage
 *
 * All router props (location, params, etc.) are forwarded to the
 * resolved component unchanged.
 */
function LandingPageRouter(props) {
  const key = getLandingPageKey();
  const PartnerPage = registry[key];
  if (PartnerPage) {
    return React.createElement(PartnerPage, props);
  }
  return React.createElement(DefaultLandingPage, props);
}

export default LandingPageRouter;
